// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1pMhO","buttons":"Footer_buttons__3j1hI"};